module.exports = __webpack_public_path__ + "static/media/person-using-google.1aa9f938.png";